module.exports = __webpack_public_path__ + "static/img/PayPal.37859592.png";